import { Component, Injectable, Input, OnInit, TemplateRef, ViewChild } from '@angular/core'

import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import {ModalConfig} from '../modal/modal.component'

@Component({
  selector: 'modalpergunta',
  templateUrl: './modalpergunta.component.html',
  styleUrls: ['./modalpergunta.component.css']
})
@Injectable({
  providedIn: 'root',
})
export class ModalperguntaComponent implements OnInit {
  @Input() public modalConfig: ModalConfig;
  @ViewChild('modalpergunta') private modalperguntaContent: TemplateRef<ModalperguntaComponent>
  isConfirmed: boolean = false;
  private modalperguntaRef: NgbModalRef
  constructor(private modalService: NgbModal) { }

  ngOnInit(): void {}

  open(): Promise<boolean> {
    this.isConfirmed = false;
    return new Promise<boolean>(resolve => {
      this.modalperguntaRef = this.modalService.open(this.modalperguntaContent, { size: '' })
      this.modalperguntaRef.result.then(resolve, resolve)
    })
  }

  async close(): Promise<void> {
    if (this.modalConfig.shouldClose === undefined || (await this.modalConfig.shouldClose())) {
      const result = this.modalConfig.onClose === undefined || (await this.modalConfig.onClose())
      this.modalperguntaRef.close(result)
    }
  }

  async dismiss(): Promise<void> {
    if (this.modalConfig.shouldDismiss === undefined || (await this.modalConfig.shouldDismiss())) {
      const result = this.modalConfig.onDismiss === undefined || (await this.modalConfig.onDismiss())
      this.modalperguntaRef.dismiss(result)
    }
  }

  continue(confirmation): Promise<boolean> {

    return new Promise<boolean>(resolve => {
      resolve(confirmation)
    })
  }

  accept() {
    this.isConfirmed = true;
    this.close();
  }

  decline() {
    this.isConfirmed = false;
    this.close();
  }

}

